import { render, staticRenderFns } from "./wangeditor.vue?vue&type=template&id=5fd2643b&scoped=true"
import script from "./wangeditor.vue?vue&type=script&lang=js"
export * from "./wangeditor.vue?vue&type=script&lang=js"
import style0 from "./wangeditor.vue?vue&type=style&index=0&id=5fd2643b&prod&lang=scss&scoped=true"
import style1 from "./wangeditor.vue?vue&type=style&index=1&id=5fd2643b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fd2643b",
  null
  
)

export default component.exports